import { api } from "./client";

export interface FleetSummary {
  devices_total: number;
  devices_online: number;
  devices_offline: number;
  devices_needs_setup: number;
  errors_last_24h: number;
  firmware_updates_last_7d: number;
  optics_last_24h: number;
}

export const summaryApi = {
  get: () =>
    api.get<{ summary: FleetSummary }>("/api/dashboard/summary"),
};
